export * from './AutoTestPage'
export * from './DetailAutoTest'
export * from './AnswerAutoTest'